import React from 'react';
import { ArtifactStatus, ArtifactType, IArtifactDTO } from '../../../../../../api/artifacts.dao';
import { IntlShape } from 'react-intl';
import DefaultButton from '../../../../../global/default-button/default-button';
import { PreviewKnovioArtifactButton } from '../../preview-artifact/preview-knovio-artifact-button';

interface IProps {
    intl: IntlShape;
    artifact: IArtifactDTO;
    downloadArtifactPermission: boolean;
    meetingId: number;
    onDownloadSingleArtifact: (assetMetadataId: number, assetName: string) => void;
    openPublishArtifactPopover: (assetMetadataId: number, meetingId: number) => void;
    onOpenKnovioPreviewLinkPopover: (meetingId: number, assetMetadataId: number) => void;
}

const ArtifactItemActionButton: React.FC<IProps> = ({
    intl,
    artifact,
    downloadArtifactPermission,
    meetingId,
    onDownloadSingleArtifact,
    openPublishArtifactPopover,
    onOpenKnovioPreviewLinkPopover,
}): JSX.Element => {
    const {
        assetType,
        assetStatus,
        assetMetadataId,
        assetName
    } = artifact;
    const isPassportReplayType = assetType === ArtifactType.PASSPORT_REPLAY;
    const isDownloadButtonVisible = !isPassportReplayType && assetStatus === ArtifactStatus.READY && downloadArtifactPermission;
    const isPublishButtonVisible = isPassportReplayType && assetStatus === ArtifactStatus.REVIEW_REQUIRED;
    const isPassportReplyPublished = isPassportReplayType && assetStatus === ArtifactStatus.PUBLISHED;

    if (isDownloadButtonVisible) {
        return (
            <td className='hoverable meeting-artifact-list-item__button'>
                <DefaultButton
                    dataTestId='download-artifact'
                    onClick={onDownloadSingleArtifact.bind(this, assetMetadataId, assetName)}
                    className='meeting-artifact-list-item__download'
                    text={intl.formatMessage({
                        id: 'oe.common.download',
                        description: 'Button label text',
                        defaultMessage: 'Download',
                    })}
                />
            </td>
        );
    } else if (isPublishButtonVisible) {
        return (
            <td className='hoverable meeting-artifact-list-item__button'>
                <DefaultButton
                    dataTestId='publish-artifact'
                    onClick={openPublishArtifactPopover.bind(this, assetMetadataId, meetingId)}
                    className='meeting-artifact-list-item__download'
                    text={intl.formatMessage({
                        id: 'oe.artifacts.reviewAndPublish',
                        description: 'Button label text',
                        defaultMessage: 'Review and Publish',
                    })}
                />
            </td>
        );
    } else if (isPassportReplyPublished) {
        return (
            <td className='hoverable meeting-artifact-list-item__button'>
                <PreviewKnovioArtifactButton
                    className='meeting-artifact-list-item__download'
                    onClick={onOpenKnovioPreviewLinkPopover.bind(this, meetingId, assetMetadataId)}
                />
            </td>
        );
    } else return <td className='hoverable'> </td>;
};

export { ArtifactItemActionButton };
